"use client";

import React, { useState } from "react";
import styles from "./ArchitectSection.module.css";

const BRAND = "#F48428";

export default function ArchitectSection({ dynamicData }) {
  const [activeIndex, setActiveIndex] = useState(0);

  if (!dynamicData) return null;

  const { mainTitle, subTitle, center, items } = dynamicData;
  const currentItem = items?.[activeIndex];

  // Distribute items for the circular layout
  // In the screenshot, there are 4 items: 2 on left, 2 on right
  const leftItems = items?.slice(0, Math.ceil(items.length / 2)) || [];
  const rightItems = items?.slice(Math.ceil(items.length / 2)) || [];

  return (
    <section className={styles.section}>
      <div className="container">
        <header className={styles.head}>
          <div className={styles.eyebrow}>ARCHITECTURE</div>
          <h2 className={styles.title}>{mainTitle}</h2>
          <p className={styles.subtitle}>{subTitle}</p>
        </header>

        <div className={styles.content}>
          {/* Circular/Spider Diagram Area */}
          <div className={styles.diagramArea}>
            <div className={styles.spiderContainer}>
              {/* Center Node */}
              <div className={styles.centerNode}>
                <div className={styles.centerInner}>{center}</div>
                <div className={styles.centerPulse}></div>
              </div>

              {/* Left Nodes */}
              <div className={styles.leftColumn}>
                {leftItems.map((item, idx) => (
                  <div
                    key={idx}
                    className={`${styles.node} ${activeIndex === idx ? styles.active : ""}`}
                    onClick={() => setActiveIndex(idx)}
                  >
                    {item.title}
                    <div className={styles.line}></div>
                  </div>
                ))}
              </div>

              {/* Right Nodes */}
              <div className={styles.rightColumn}>
                {rightItems.map((item, idx) => {
                  const actualIdx = idx + leftItems.length;
                  return (
                    <div
                      key={actualIdx}
                      className={`${styles.node} ${activeIndex === actualIdx ? styles.active : ""}`}
                      onClick={() => setActiveIndex(actualIdx)}
                    >
                      {item.title}
                      <div className={styles.line}></div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Details Box */}
          <div className={styles.detailsArea}>
            {currentItem && (
              <div className={styles.detailsCard}>
                <h3 className={styles.detailTitle}>{currentItem.title}</h3>
                <p className={styles.detailDesc}>{currentItem.description}</p>

                {currentItem.points && currentItem.points.length > 0 && (
                  <div className={styles.pointsWrap}>
                    <h4 className={styles.pointsTitle}>Core Technologies</h4>
                    <ul className={styles.pointsList}>
                      {currentItem.points.map((p, pIdx) => (
                        <li key={pIdx}>{p}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
